import { CloseModal } from 'domain/usecases/modal/redux/CloseModal';
import { iActionClose, ModalTypes } from 'domain/interfaces/redux/modal/close';

export const closeRequest = (payload: CloseModal.Params): iActionClose => ({
  type: ModalTypes.CLOSE,
  payload,
});
